exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".index__image___2Vjfz {\n  height: 270px;\n  object-fit: cover;\n}\n", "",{"version":3,"sources":["index.less"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;AACnB","file":"index.less","sourcesContent":[".image {\n  height: 270px;\n  object-fit: cover;\n}\n"]}]);

// Exports
exports.locals = {
	"image": "index__image___2Vjfz"
};